import { render, staticRenderFns } from "./WGModalFirstPage.vue?vue&type=template&id=041da5ab&scoped=true&"
import script from "./WGModalFirstPage.vue?vue&type=script&lang=js&"
export * from "./WGModalFirstPage.vue?vue&type=script&lang=js&"
import style0 from "./WGModalFirstPage.vue?vue&type=style&index=0&id=041da5ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041da5ab",
  null
  
)

export default component.exports